<youtube-player [videoId]="videoId" suggestedQuality="highres">
</youtube-player>